import { WinFormsContentScreen } from '@winforms';
import { __asyncI18n } from '@localisation';
import { RoutingEntry } from '@routing';
import { RoutePrivilegeNames } from './routeprivilegenames';
import { DummySiteComponent } from '@site-info';
import { PlantAdministrationListComponent, PlantApplicationSetNaviExtension, CanActivateWithCurrentTenant } from '@plants';

export const PlantAdministrationRoutes: Array<RoutingEntry> = [
    {
        path: '',
        component: PlantAdministrationListComponent,
        data: {
            title: __asyncI18n('Plants', 'subnavi.administration.plants'),
            contentRoute: '/Site/SiteAdministration/List',
            redirectTo: 'Administrations/Plants/:plantid/*firstChild',
            favouritesType: 'siteadministration'
        }
    },
    {
        path: 'ActivatingSite',
        component: WinFormsContentScreen,
        data: {
            title: __asyncI18n('Activating plants', 'subnavi.administration.activating-plants'),
            contentRoute: '/Site/SiteAdministration/ActivatingSite',
            showParentInSubNavigation: true
        }
    },
    {
        path: ':plantid',
        canActivate: [CanActivateWithCurrentTenant],
        data: {
            title: ':plantid | plantIdToName',
            showParentInSubNavigation: true,
            showChildrenAsSecondLevel: true,
            dontShowInSubNavigation: true,
            favouritesRouteCaption: '[PlantName] / [PageName]',
            redirectTo: [
                'Administration/Plants/:plantid/Settings',
                'Administration/Plants/:plantid/Users',
                'Administration/Plants/:plantid/Alarms'
               //'Administration/Plants/:plantid/*firstChild'
            ],
        },
        children: [
            {
                path: '',
                component: DummySiteComponent,
                data: {
                    title: ':plantid | plantIdToName',
                    showParentInSubNavigation: true,
                    showChildrenAsSecondLevel: true,
                    dontShowInSubNavigation: true,
                    favouritesRouteCaption: '[PlantName] / [PageName]',
                    redirectTo: [
                        'Administration/Plants/:plantid/Settings',
                        'Administration/Plants/:plantid/Users',
                        'Administration/Plants/:plantid/Alarms'
                    ]
                }
            },
            {
                path: 'Details',
                component: WinFormsContentScreen,
                data: {
                    title: __asyncI18n('Details', 'subnavi.administration.plant.details'),
                    contentRoute: '/Site/SiteAdministration/Details/:plantid',
                    dontShowInSubNavigation: true,
                    testId: 'sidenavigation.link.details'
                }
            },
            {
                path: 'Users',
                data: {
                    title: __asyncI18n('Plant users', 'subnavi.administration.plant.plant.users'),
                    contentRoute: '/Site/SiteAdministration/Users/:plantid',
                    testId: 'sidenavigation.link.plantusers',
                    privileges: [RoutePrivilegeNames.ManagePlantUsers]
                },
                children: [
                    {
                        path: '',
                        component: WinFormsContentScreen,
                        data: {
                            title: __asyncI18n('Plant users TEST', 'subnavi.administration.plant.plant.user.test'),
                            contentRoute: '/Site/SiteAdministration/Users/:plantid'
                        }
                    },
                    {
                        path: 'Add',
                        component: WinFormsContentScreen,
                        data: {
                            title: __asyncI18n('Add user', 'subnavi.administration.plant.user.add'),
                            contentRoute: '/Site/SiteAdministration/SiteUser/:plantid',
                            showParentInSubNavigation: true
                        }
                    },
                    {
                        path: ':userid',
                        component: WinFormsContentScreen,
                        data: {
                            title: ':userid | userIdToName',
                            contentRoute: '/Site/SiteAdministration/SiteUser/:plantid?userId=:userid',
                            showParentInSubNavigation: true
                        }
                    }
                ]
            },
            {
                path: 'Alarms',
                data: {
                    title: __asyncI18n('Plant notifications', 'subnavi.administration.plant.alarms'),
                    contentRoute: '/Site/SiteAdministration/Alarms/:plantid',
                    testId: 'sidenavigation.link.alarmnotifications',
                    privileges: [RoutePrivilegeNames.PlantAlarmNotification, RoutePrivilegeNames.NotificationAccess],
                },
                children: [
                    {
                        path: '',
                        component: WinFormsContentScreen,
                        data: {
                            title: __asyncI18n('Plant notifications', 'subnavi.administration.plant.alarms'),
                            contentRoute: '/Site/SiteAdministration/Alarms/:plantid'
                        }
                    },
                    {
                        path: 'Add',
                        component: WinFormsContentScreen,
                        data: {
                            title: __asyncI18n('Add notifications', 'subnavi.administration.plant.add-alarm'),
                            contentRoute: '/Site/SiteAdministration/SiteAlarm/:plantid',
                            showParentInSubNavigation: true,
                            favouritesTitle: '[ParentPageName]'
                        }
                    },
                    {
                        path: 'CreateFromTemplate',
                        component: WinFormsContentScreen,
                        data: {
                            title: __asyncI18n(
                                'Create plant notification from template',
                                'subnavi.administration.plant.create-alarm-from-template'
                            ),
                            contentRoute: '/Site/SiteAdministration/CreateAlarmFromTemplate/:plantid',
                            showParentInSubNavigation: true,
                            favouritesTitle: '[ParentPageName]'
                        }
                    },
                    {
                        path: ':alarmnotificationsid',
                        component: WinFormsContentScreen,
                        data: {
                            title: ':alarmnotificationsid | plantAlarmNoteIdToName',
                            contentRoute: '/Site/SiteAdministration/SiteAlarm/:plantid?alarmId=:alarmnotificationsid',
                            showParentInSubNavigation: true,
                            favouritesTitle: '[ParentPageName]',
                            favouritesCaption: '[ParentParentPageName] / [AlarmNoteName]'
                        }
                    }
                ]
            },
            {
                path: 'Settings',
                data: {
                    title: __asyncI18n('Plant settings', 'subnavi.administration.plant.settings'),
                    contentRoute: '/Site/SiteAdministration/Settings/:plantid',
                    testId: 'sidenavigation.link.settings',
                    dynamicSiblings: PlantApplicationSetNaviExtension,
                    privileges: [RoutePrivilegeNames.ManagePlantSettings]
                },
                children: [
                    {
                        path: '',
                        component: WinFormsContentScreen,
                        data: {
                            title: __asyncI18n('Plant settings', 'subnavi.administration.plant.settings'),
                            contentRoute: '/Site/SiteAdministration/Settings/:plantid',
                            dynamicSiblings: PlantApplicationSetNaviExtension
                        }
                    },
                    {
                        path: 'ReplacingSite',
                        component: WinFormsContentScreen,
                        data: {
                            title: __asyncI18n('Replaceing plant', 'subnavi.administration.plant.replacing-site'),
                            contentRoute: '/Site/SiteAdministration/ReplacingSite/:plantid',
                            showParentInSubNavigation: true
                        }
                    },
                    {
                        path: 'AssignUnassignSite',
                        component: WinFormsContentScreen,
                        data: {
                            title: __asyncI18n('Assign/Unassign plant', 'subnavi.administration.plant.assignunassign-site'),
                            contentRoute: '/Site/SiteAdministration/AssignUnassignSite/:plantid',
                            showParentInSubNavigation: true
                        }
                    }
                ]
            },
            {
                path: 'ConfirmDelete',
                component: WinFormsContentScreen,
                data: {
                    title: __asyncI18n('Confirm delete', 'subnavi.administration.plant.confirmdelete'),
                    contentRoute: '/Site/SiteAdministration/ConfirmDelete/:plantid',
                    testId: 'sidenavigation.link.confirmdelete',
                    dontShowInSubNavigation: true
                }
            },

            {
                path: 'Operating',
                component: WinFormsContentScreen,
                data: {
                    title: __asyncI18n('Plant operating', 'subnavi.administration.plant.operating'),
                    redirectTo: 'Operating/Plants/:plantid',
                    testId: 'sidenavigation.link.operating',
                    privileges: [
                        [
                            [
                                RoutePrivilegeNames.PlantDashboard,
                                RoutePrivilegeNames.CloudItem,
                                RoutePrivilegeNames.PlantUpgrade,
                                RoutePrivilegeNames.WebAccess,
                                RoutePrivilegeNames.ToolAccess,
                                RoutePrivilegeNames.PlantFileAccess,
                                RoutePrivilegeNames.PlantFileManage,
                                RoutePrivilegeNames.PlantAlarm,
                                RoutePrivilegeNames.PlantGraphic,
                                RoutePrivilegeNames.PlantHistory,
                                RoutePrivilegeNames.PlantTasks,
                                RoutePrivilegeNames.PlantScheduler,
                                RoutePrivilegeNames.PlantDashboard,
                            ],
                            RoutePrivilegeNames.PlantOperating
                        ]
                    ]
                }
            }
        ]
    }
];
